export default __webpack_public_path__ + "static/media/img-proj-cmbus-pos.66e18f63.png";